import type * as SchemaTypes from '../types';

import { gql } from '@apollo/client';
export type BankDealerMarketDataFragment = (
  { __typename: 'BankDealershipMarket' }
  & Pick<SchemaTypes.BankDealershipMarket, 'editable'>
  & { overrides: Array<(
    { __typename: 'BankDealershipMarketOverrides' }
    & Pick<SchemaTypes.BankDealershipMarketOverrides, 'dealerId' | 'editable'>
  )> }
);

export const BankDealerMarketDataFragmentDoc = /*#__PURE__*/ gql`
    fragment BankDealerMarketData on BankDealershipMarket {
  editable
  overrides {
    dealerId
    editable
  }
}
    `;